import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Upload Link Preview Image
  [types.UPLOAD_LINK_PREVIEW_REQUEST]: state => {
    return {
      ...state,
      loading: true
    };
  },

  [types.UPLOAD_LINK_PREVIEW_DONE]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      data: payload
    };
  },

  [types.UPLOAD_LINK_PREVIEW_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      errors_api: payload
    };
  },

  [types.UPLOAD_LINK_PREVIEW_RESET]: () => {
    return {
      ...initialState
    };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
